<template>
    <BaseDialog v-model:open="isOpen" :title="t('connections.csvImport.title')">
        <CsvImportContent v-bind="props" :footer-target="`#${footerId}`" @imported="handleImported" @close="isOpen = false" @importing="isImporting = $event" />
        <template v-if="!isImporting" #footer>
            <div :id="footerId" class="contents"></div>
        </template>
    </BaseDialog>
</template>

<script setup lang="ts">
import type { CsvImportStatusResponse } from "~vue/api/generated/connections-csv";
import BaseDialog from "~vue/components/BaseDialog.vue";
import CsvImportContent from "~vue/Connections/CsvImportContent.vue";
import AmplitudeEventNames from "~vue/utils/amplitudeEventNames";
import { logUserInteraction } from "~vue/utils/logUtils";
import { ref, useId, watch } from "vue";
import { useI18n } from "vue-i18n";

type ImportResult = Pick<CsvImportStatusResponse, "created" | "updated" | "skipped" | "errors">;

const props = defineProps<{ csvTemplateUrl: string; csvPreviewUrl: string; csvImportUrl: string }>();
const emit = defineEmits<{ imported: [result: ImportResult] }>();
const isOpen = defineModel<boolean>("open", { default: false });
const { t } = useI18n();
const footerId = useId();
const isImporting = ref(false);

const handleImported = (result: ImportResult) => {
    isOpen.value = false;
    emit("imported", result);
};

watch(isOpen, (open) => {
    if (open) {
        logUserInteraction(AmplitudeEventNames.CSV_IMPORT_DIALOG_OPENED);
    } else {
        isImporting.value = false;
    }
});
</script>
